<template>
    <section class="mine-gift vh100">
        <div v-if="sendCourses.length">
            <div class="mine-gift-item"
                v-for="course in sendCourses"
                :key="course.token">
                <div class="mine-gift-item-image"
                    :style="{ 'background-image': `url(${ course.image })` }"></div>
                <div class="mine-gift-item-name"
                    :class="{ 'disable': course.status === 3, 'no-pay': course.status === 1 }"
                    @click="handleClick(course)">
                    {{ course.title }}
                </div>
            </div>
        </div>
        <div v-else>
            <img src="../assets/images/mine-icon-no-gift.png"
                class="mine-gift-empty-img" />
            <div class="mine-gift-empty-button"
                @click="handleNavigate">去选课</div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'MineGift',
  props: {
    sendCourses: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    handleClick (course) {
      /**
             * status 赠送状态
             * @value
             * 1: 未支付
             * 2: 已支付未赠送
             * 3: 已赠送
             */
      if (course.status === 1) {
        this.$router.push(`/pay?isSend=1&courseId=${course.courseId}`)
      } else if (course.status === 2) {
        this.$router.push(`/gift?shareId=${course.token}`)
      }
    },
    handleNavigate () {
      this.$router.push(`/recommend`)
    }
  }
}
</script>

<style lang="scss" scoped>
    @import "../style/main";

    .mine-gift {
        overflow-y: scroll;
        padding: rem(30);
        /*height: 100%;*/
        background-color: #f3f4f6;

        &-item {
            display: flex;
            margin-bottom: rem(40);
            padding: rem(30);
            border-radius: 4px;
            background-color: #fff;

            &-image {
                margin-right: rem(30);
                width: rem(150);
                height: rem(190);
                border-radius: 6px;
                background-size: cover;
            }

            &-name {
                flex: 1;
                position: relative;
                font-size: rem(30);
                color: #333;

                &::after {
                    content: '立即赠送';
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    padding: rem(12) rem(24);
                    border: 1px solid #f48f00;
                    border-radius: 3px;
                    font-size: rem(24);
                    color: #f48f00;
                }

                &.disable {
                    &::after {
                        content: '已赠送';
                        border-color: #999;
                        color: #999;
                    }
                }

                &.no-pay {
                    &::after {
                        content: '未支付';
                    }
                }
            }
        }

        &-empty {
            &-img {
                display: block;
                margin: rem(225) auto rem(60);
                width: rem(460);
            }

            &-button {
                margin: 0 auto;
                padding: rem(10) 0;
                width: rem(168);
                border-radius: 3px;
                background-color: #f48f00;
                text-align: center;
                font-size: rem(28);
                color: #fff;
            }
        }
    }
</style>
